if (typeof window.FooterFeature === 'undefined') {
  class FooterFeature {
    constructor(splideContainer) {
      this.splideContainer = splideContainer;
      this.splideList = this.splideContainer?.querySelector('.splide__list');
      this.splideInstance = undefined;
      this.pagination = this.splideContainer?.closest('.container')?.querySelector('.js-footer-feature-pagination');
      this.init();
    }
 
    init() {
      if (!this.splideContainer || typeof window.Splide === 'undefined') return;
      this.enableSplide();
    }

    enableSplide() {
      if (!this.splideInstance) {
        this.splideInstance = new window.Splide(this.splideContainer, {
          arrows: false,
          type: 'slide',
          perPage: 1,
          gap: '2rem',
          pagination: true,
          duration: 1500,
          dragMinThreshold: 5,
          flickPower: 100,
          mediaQuery: 'min',
          breakpoints: {
            1024: {
              destroy: true,
            },
          }
        }).mount();
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.js-footer-feature-splide').forEach(function(splide) {
      new FooterFeature(splide);
    });
  });
}
